import { executeRequest, Request } from '@jfs/network'

import { RootStore } from '../data/store'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
import { isLocalHostUrl } from './fetchGroupByRiskAudit'

const responseParser = (data: any) => {
  return data
}

const downloadRiskTnxsEvidence: any = (entityId: string, docId: string) => {
  const data = new FormData()
  data.append('docId', docId)
  data.append('entityId ', entityId)

  const config = sitConfig(RootStore.session.getTokens)

  const request: Request<{}> = {
    config: config,
    apiPath: isLocalHostUrl
      ? 'http://localhost:8080/api/v1.0/risk/evidence/download'
      : getUrl(APIEndPoints.downloadEvidence),
    method: 'POST',
    headers: { ...getHeaders(), 'Content-Type': 'multipart/form-data', ...(isLocalHostUrl && { appIDToken: '66', 'x-channel-id': '66' }) },
    responseType: 'arraybuffer',
    body: data,
  }
  return executeRequest(request).then((data) => {
    return responseParser(data)
  })
}

export { downloadRiskTnxsEvidence }
